import React, { useEffect, useState } from 'react'
import notify from "../UseNotification"
import { useDispatch, useSelector } from 'react-redux'
import { register } from '../../redux/Slices/AuthSlice'
import { useNavigate } from 'react-router-dom'
const UseSignUp = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const egyptPhoneRegex = /^(010|011|012|015)\d{8}$/;
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { AddUser } = useSelector(state => state.AuthReducer)
    const [userName, setUserName] = useState('')
    const [userMail, setUserMail] = useState('')
    const [userPhone, setUserPhone] = useState('')
    const [userPassword, setUserPassword] = useState('')
    const [userConfirmPassword, setConfirmPassword] = useState('')
    const [loading, setLoading] = useState()
    const [isPress, setIsPress] = useState(false)
    const [isFormValid, setIsFormValid] = useState(false)


    // set user name
    const OnChangeUserName = (e) => {
        setUserName(e.target.value)
    }
    // set user mail
    const OnChangeUserMail = (e) => {
        setUserMail(e.target.value)
    }
    // set user phone
    const OnChangeUserPhone = (e) => {
        setUserPhone(e.target.value)
    }
    // set user password
    const OnChangeUserPassword = (e) => {
        setUserPassword(e.target.value)
    }
    // set user confirm password
    const OnChangeUserConfirmPassword = (e) => {
        setConfirmPassword(e.target.value)
    }

    // on Blur User Name Validation
    const UserNameValidation = (e) => {
        if (e.target.value.length < 3) {
            notify("User Name at least 3 character", "error")
        }
    }

    // on Blur User email Validation
    const UserEmailValidation = (e) => {
        if (e.target.value === "") {
            notify("you must enter the email", "error")
        }
        else if (!e.target.value.match(emailRegex)) {
            notify("please enter correct email", "error")
        }
    }

    // on Blur User phone Validation
    const UserPhoneValidation = (e) => {
        if (e.target.value === "") {
            notify("you must enter phone", "error")
        } else if (!e.target.value.match(egyptPhoneRegex)) {
            notify("phone is not egyption number", "error")
        }
    }

    // on Blur User password Validation
    const UserPasswordValidation = (e) => {
        if (e.target.value.length < 6) {
            notify("Password at least 6 character", "error")
        }
    }

    // on Blur User password Confirm Validation
    const UserPasswordConfirmationValidation = (e) => {
        if (e.target.value.length < 6) {
            notify("Password at least 6 character", "error")
        } else if (userConfirmPassword != userPassword) {
            notify("Password is not matched", "error")
        }
    }

    // to handle disable submit button
    useEffect(() => {
        if (userName && userMail && userPhone && userPassword && userConfirmPassword && userMail.match(emailRegex) && userName.length > 2 && userPhone.match(egyptPhoneRegex) && userPassword.length >= 6 && userConfirmPassword === userPassword) {
            setIsFormValid(true)
        } else {
            setIsFormValid(false)
        }
    }, [userName, userMail, userPhone, userPassword, userConfirmPassword])


    // Submit function
    const RegisterSubmit = async () => {
        setIsPress(true)
        setLoading(true)
        await dispatch(register({
            "name": userName,
            "email": userMail,
            "phone": userPhone,
            "password": userPassword,
            "passwordConfirm": userConfirmPassword,
        }))
        setLoading(false)
    }

    // to handle response after dispatch request
    useEffect(() => {
        if (loading === false) {
            setIsPress(false)
            if (AddUser) {
                if (AddUser.data) {
                    localStorage.setItem("token", AddUser.data.token);
                    notify("Success Registeration", "success");
                    navigate("/login")
                }
                else if (AddUser.response) {
                    localStorage.removeItem("token");
                    AddUser.response.data.errors.map(item => notify(item.msg, "error"))
                }
            }
        }
    }, [loading])


    return [isPress, loading, userName, userMail, userPhone, userPassword, userConfirmPassword,
        OnChangeUserName, OnChangeUserMail, OnChangeUserPhone, OnChangeUserPassword, OnChangeUserConfirmPassword, RegisterSubmit, UserNameValidation, UserEmailValidation, UserPhoneValidation, UserPasswordValidation, UserPasswordConfirmationValidation, isFormValid]
}

export default UseSignUp
